export function accountIndicator(status) {
  if (!status || status.has_account !== true || status.has_username === false) {
    return { state: 'no-username', icon: 'mdi-account-remove-outline', color: 'red', tooltip: 'account_no-username' };
  }
  if (status.active_account !== true) {
    return { state: 'expired', icon: 'mdi-lock', color: 'red', tooltip: 'account_locked' };
  }
  if (status.expires_soon === true) {
    return { state: 'warn', icon: 'mdi-lock-clock', color: 'orange', tooltip: 'account_warn' };
  }
  return { state: 'ok', icon: 'mdi-lock-open', color: 'green', tooltip: 'account_unlocked' };
}
